import { render } from "./PolicyView.vue?vue&type=template&id=829fd582"
import script from "./PolicyView.vue?vue&type=script&lang=js"
export * from "./PolicyView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__